import { useStorageClient } from "../storage/StorageClientProvider";
import type { StorageClient } from "../storage/types";

export const useCookieStore = () => {
  const storageClient = useStorageClient() as StorageClient;
  return storageClient.get("cookie");
};
